import { render, staticRenderFns } from "./modalCrearGrupo.vue?vue&type=template&id=4b46a018&"
import script from "./modalCrearGrupo.vue?vue&type=script&lang=js&"
export * from "./modalCrearGrupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports